export const form_po_visibility = {
  dispatch_summary: [
    {
      label: "receive_consignor",
      // label: 'customer_label_pov',
      type: "info",
      id: "Consignor",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_consignee",
      type: "info",
      // typeValue: 'number',
      id: "Consignee",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_dcn_reference_no",
      type: "info",
      id: "ReferenceNo",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_destination",
      type: "info",
      id: "Destination",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_numberpackages",
      type: "info",
      id: "Numberpackages",
      class: "_align _name",
      colm: 2,
      md: 3,
    },

    {
      label: "dispatch_Pack",
      type: "info",
      id: "DCNRelease",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "dispatch_load",
      type: "info",
      id: "Load",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_unloaded",
      type: "info",
      id: "Unloaded",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_finalized",
      type: "info",
      id: "Finalized",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_TotalWeight",
      type: "info",
      id: "TotalWeight",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
    {
      label: "receive_totalvolume",
      type: "info",
      id: "Totalvolume",
      class: "_align _name",
      colm: 2,
      md: 3,
    },
  ],
};
